module.exports = __webpack_public_path__ + "static/media/028-Delice Resto Lounge.98fc6797.jpg";